import { BusIcon, HomeIcon, MapIcon, UserIcon } from "assets/icons";
import { Link, useLocation } from "react-router-dom";
import routes from "routes";

function BottomTab() {
  const location = useLocation();
  const tabs = [
    {
      label: "Home",
      icon: <HomeIcon />,
      link: "/",
    },
    {
      label: "My Booking",
      icon: <BusIcon />,
      link: routes.bookTicket,
    },
    {
      label: "Explore",
      icon: <MapIcon />,
      link: routes.explore,
    },
    {
      label: "My Account",
      icon: <UserIcon />,
      link: "/my-account",
    },
  ];

  return (
    <div className="w-full flex flex-col">
      <div className="fixed bottom-0 left-0 right-0 bg-white h-[80px] shadow-block flex items-center justify-between gap-2 margins z-[9999]">
        {tabs.map((item, index) => (
          <Link
            key={index}
            className={`flex flex-col items-center gap-2 ${
              location.pathname === item.link
                ? "text-primary-700"
                : "text-[#858585]"
            }`}
          >
            <div className="h-5 w-5">{item.icon}</div>
            <div className="text-[12px] font-bold">{item.label}</div>
          </Link>
        ))}
      </div>
      <div className="h-[80px]" />
    </div>
  );
}

export default BottomTab;
